<script setup>
import { inject, computed } from 'vue';
import { useProductsStore } from '@/app/stores/productsStore.js';
import { useValue } from '@/app/composables/useValue.js';

const productsStore = useProductsStore();

const config = inject('config');
const props = defineProps(['dataPoint']);
const system = computed(() => productsStore.system);

const rangeData = computed(() => {
  return {
    primaryValue:
      (`${system.value}ValueRange` in props.dataPoint &&
        props.dataPoint[`${system.value}ValueRange`][0]?.toString()) ||
      ('valueRange' in props.dataPoint && props.dataPoint.valueRange[0]?.toString()) ||
      '',
    secondaryValue:
      (`${system.value}ValueRange` in props.dataPoint &&
        props.dataPoint[`${system.value}ValueRange`][1]?.toString()) ||
      ('valueRange' in props.dataPoint && props.dataPoint.valueRange[1]?.toString()) ||
      '',
    unit: props.dataPoint[`${system.value}Unit`] || props.dataPoint.unit || '',
    optionalPrimaryValue:
      (system.value === 'imperial' && props.dataPoint.imperialValueOptionalRange?.[0]) || '',
    optionalSecondaryValue:
      (system.value === 'imperial' && props.dataPoint.imperialValueOptionalRange?.[1]) || '',
    optionalPrimaryUnit:
      (system.value === 'imperial' &&
        props.dataPoint.imperialValueOptionalRange?.[0] &&
        props.dataPoint.imperialUnitOptional) ||
      '',
    optionalSecondaryUnit:
      (system.value === 'imperial' &&
        props.dataPoint.imperialValueOptionalRange?.[1] &&
        props.dataPoint.imperialUnitOptional) ||
      '',
  };
});

const rangeTextFrom = computed(
  () => `
     ${useValue(rangeData.value.primaryValue)} ${rangeData.value.unit} ${useValue(
    rangeData.value.optionalPrimaryValue,
  )} ${rangeData.value.optionalPrimaryUnit} `,
);

const rangeTextTo = computed(
  () =>
    `${useValue(rangeData.value.secondaryValue)} ${rangeData.value.unit} ${useValue(
      rangeData.value.optionalSecondaryValue,
    )} ${rangeData.value.optionalSecondaryUnit}`,
);
</script>

<template>
  <div
    v-if="rangeData.primaryValue"
    class="c-product-card__details-set"
    itemprop="additionalProperty"
    itemscope
    itemtype="https://schema.org/PropertyValue"
  >
    <dt class="c-product-card__details-title" itemprop="name">{{ dataPoint.title }}</dt>
    <dd class="c-product-card__details-data" itemprop="value">
      <span class="c-product-card__details-data-range">{{ rangeTextFrom }}-&nbsp;</span
      ><span class="c-product-card__details-data-range">{{ rangeTextTo }}</span>
    </dd>
  </div>
</template>